<template>
<router-link :to="`/collectiondetails/${collection?.id}`">
    <div class="painting-card flex flex-col">
            <div :style="`background:url(${collection?.image})`" class="h-[350px] painting-img"></div>

            <div class="w-full h-[1px] bg-line mt-8 mb-4"></div>
            <div class="lg:text-3xl text-2xl lg:mb-4 mb-2">{{collection.title}}</div>
            <div class="text-base"> {{collection.year.substring(0,4)}}</div> 

    </div></router-link>
</template>
<script>
export default {
    props:['collection'],
}
</script>